module.exports = __webpack_public_path__ + "img/Logout.ea8b7ccd.svg";